module.exports = __webpack_public_path__ + "static/bone_whelk-4f12b7681ee13c9664bea0bde16602f0.jpeg";